import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/element/constrainable/handle/styles.scss';export default {
  "handle": "_handle_wi7x8_1",
  "icon": "_icon_wi7x8_10",
  "leftHandler": "_leftHandler_wi7x8_16",
  "rightHandler": "_rightHandler_wi7x8_23"
};